var FORM_FIELD = 'form_field';
var BLOCK_ID = 'amortization_calc';
var TOOLTIP = 'tooltip';

export { BLOCK_ID, FORM_FIELD, TOOLTIP };
